import { useState } from 'react';
import type { AssociationGroup, VariationType, CreateProductGroupItemDto } from '@/lib/types';
import type { Step, AssociationManagerState } from './types';

export function useAssociationState() {
  const [step, setStep] = useState<Step>('select_group');
  const [selectedGroup, setSelectedGroup] = useState<AssociationGroup | null>(null);
  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [newGroupName, setNewGroupName] = useState('');
  const [newGroupDescription, setNewGroupDescription] = useState('');
  const [newGroupVariationType, setNewGroupVariationType] = useState<VariationType>('related');
  const [variantConfigs, setVariantConfigs] = useState<Record<string, CreateProductGroupItemDto>>({});
  const [groupToDelete, setGroupToDelete] = useState<AssociationGroup | null>(null);
  const [groupToEdit, setGroupToEdit] = useState<AssociationGroup | null>(null);
  const [editGroupName, setEditGroupName] = useState('');
  const [editGroupDescription, setEditGroupDescription] = useState('');

  const resetState = () => {
    setStep('select_group');
    setSelectedGroup(null);
    setSelectedProductIds([]);
    setSearchQuery('');
    setNewGroupName('');
    setNewGroupDescription('');
    setNewGroupVariationType('related');
    setVariantConfigs({});
    setGroupToEdit(null);
    setEditGroupName('');
    setEditGroupDescription('');
    setGroupToDelete(null);
  };

  const resetGroupForm = () => {
    setSelectedGroup(null);
    setNewGroupName('');
    setNewGroupDescription('');
    setNewGroupVariationType('related');
    setGroupToEdit(null);
    setEditGroupName('');
    setEditGroupDescription('');
  };

  const state: AssociationManagerState = {
    step,
    selectedGroup,
    selectedProductIds,
    searchQuery,
    newGroupName,
    newGroupDescription,
    newGroupVariationType,
    variantConfigs,
    groupToDelete,
    groupToEdit,
    editGroupName,
    editGroupDescription,
  };

  const setters = {
    setStep,
    setSelectedGroup,
    setSelectedProductIds,
    setSearchQuery,
    setNewGroupName,
    setNewGroupDescription,
    setNewGroupVariationType,
    setVariantConfigs,
    setGroupToDelete,
    setGroupToEdit,
    setEditGroupName,
    setEditGroupDescription,
  };

  return {
    state,
    setters,
    resetState,
    resetGroupForm,
  };
}
